var PromoSlider = {};
PromoSlider.slider = function () {
  var $promoSlider = $('.js-promo-slider');
  if ($promoSlider.length === 0) {
    return;
  }
  $.each($promoSlider, function () {
    var $slider = $(this);
    var isSquareSlider = false;

    // Desktop Square
    if ($slider.hasClass('is-square') && matchMedia('screen and (min-width: 992px)').matches) {
      isSquareSlider = 2;
    }

    // Mobile Square
    else if ($slider.hasClass('is-square') && matchMedia('screen and (max-width: 991px)').matches) {
      isSquareSlider = 1;
    }

    // Greater than 2
    var elChild = $slider.find('.promo-cont-item').length > 2 ? true : false;
    if (elChild) {
      $slider.flickity({
        pageDots: true,
        contain: false,
        cellAlign: 'center',
        percentPosition: false,
        dragThreshold: 3,
        prevNextButtons: true,
        groupCells: isSquareSlider,
        wrapAround: true,
        selectedAttraction: 0.01,
        friction: 0.15,
        freeScrollFriction: 0.02,
        fullscreen: true
      });
    } else {
      $slider.flickity({
        pageDots: true,
        contain: false,
        cellAlign: 'left',
        percentPosition: false,
        dragThreshold: 3,
        prevNextButtons: true,
        groupCells: false,
        wrapAround: false,
        selectedAttraction: 0.01,
        friction: 0.15,
        freeScrollFriction: 0.02,
        fullscreen: true
      });
    }
    $slider.on('change.flickity', function (event) {
      PromoSlider.childSelect(event.target.children[0].children[0].children);
    });
    $slider.on('fullscreenChange.flickity', function (event, isFullscreen) {
      PromoSlider.changeImageOnFullscreen($(this), isFullscreen);
    });
    $slider.on('click', '.promo-cont-item:not(.has-video)', function () {
      var currentItem = this;
      if (matchMedia('screen and (max-width: 991px)').matches) {
        $slider.find('.flickity-fullscreen-button-view').trigger('click');
      }
      if (matchMedia('screen and (min-width: 992px)').matches) {
        var zoomImage = $(currentItem).attr('data-zoom-image-desktop');
        if ($(currentItem).hasClass('is-square')) {
          $('.js-zoom-image').addClass('is-square');
        }
        $('.js-zoom-image .js-zoom-image-src').attr('src', zoomImage);
        $('#threePromo-modal').modal('show');
        $slider.flickity('resize');
      }
    });
  });
  $(document).find('.js-zoom-image').off('click').on('click', function (e) {
    $(this).closest('.modal-dialog').toggleClass('is-zoom');
  });
  $('#threePromo-modal').on('hidden.bs.modal', function (e) {
    $(this).find('.modal-dialog').removeClass('is-zoom');
    $('.js-zoom-image .js-zoom-image-src').attr('src', '#');
    $('.js-zoom-image').removeClass('is-square');
  });
};
PromoSlider.childSelect = function (e) {
  for (var i = 0; i < e.length; i++) {
    if (!e) return;
    if (e[i].className != 'promo-cont-item is-selected') {
      for (var x = 0; x < e[i].children[0].childNodes.length; x++) {
        var ele = e[i].children[0].childNodes[x].tagName;
        if (typeof ele != 'undefined') {
          if (ele.toLowerCase() === 'iframe') {
            var eleUrl = $('#' + e[i].children[0].childNodes[x].id).prop('src');
            if (eleUrl.search('&autoplay=1') > -1) {
              eleUrl = eleUrl.replace('&autoplay=1', '');
              $('#' + e[i].children[0].childNodes[x].id).prop('src', '');
              $('#' + e[i].children[0].childNodes[x].id).prop('src', eleUrl);
            } else if (eleUrl.search('vimeo') > -1) {
              var player = new Vimeo.Player(e[i].children[0].childNodes[x].id);
              window.Video.hideElement(e[i].children[0].childNodes[x].parentNode.querySelectorAll('.js-hide-on-play'), 'show');
              player.pause();
            }
          }
          if (ele.toLowerCase() === 'video') {
            e[i].children[0].childNodes[x].pause();
            window.Video.hideElement(e[i].children[0].childNodes[x].parentNode.querySelectorAll('.js-hide-on-play'), 'show');
          }
        }
      }
    }
    if (i > 10000) break;
  }
};
PromoSlider.changeImageOnFullscreen = function (slider, isFullscreen) {
  var sliderItems = slider.find('.promo-cont-item');
  if (!sliderItems) {
    return;
  }
  sliderItems.each(function () {
    var selectedImage = $(this);
    var selectedImageImg = $(this).find('img.d-block');
    var srcset = selectedImageImg.data('srcset');
    var src = isFullscreen ? selectedImage.data('zoom-image-mobile') : selectedImageImg.data('src');
    selectedImageImg.attr('src', src);
    if (isFullscreen && srcset) {
      selectedImageImg.removeAttr('srcset');
      slider.attr('style', 'background-color:#303030; transition: all 0s');
    } else {
      selectedImageImg.attr('srcset', srcset);
      slider.attr('style', 'background-color:transparent; transition: all 0s');
    }
  });
};
PromoSlider.slider();
window.PromoSlider = PromoSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/promo-slider.js